<script lang="ts">
	import Button from "../materialize/components/Button.svelte";
	import Icon from "../materialize/components/Icon.svelte";
	function share()
	{
		if (window.hasOwnProperty("AndroidInterface"))
		{
			AndroidInterface.share_text(share_title, share_text);
			M.toast({html: 'Grazie per aver condiviso'});
		}
		else if (navigator.share)
		{
			navigator.share({
			title: share_title,
			url: share_url,
			text: share_text
			});
			//M.toast({html: 'Condiviso navigator.share', classes: 'rounded'});
		}
		else
		{
			//M.toast({html: 'Impossibile condividere!', classes: 'rounded'});
		}
	}
	export let share_title: string;
	export let share_url: string;
	export let share_text: string;

	export let button_flat: boolean = true;
	export let button_text: string;
	export let class_list: string[];
</script>

{#if window.hasOwnProperty("AndroidInterface") || (navigator && navigator.share ) }
	<Button {class_list} waves="approu-primary" flat={button_flat} on:click={share}>
		<Icon icon="share"/>	
	</Button>
{/if}

